// import { isBrowser } from './utils';
import { getCookie, LOG } from './utils';

export default function (variable = 'NODE_ENV') {
  const envCookie = getCookie('apa_e');

  LOG('[environment] variable', process.env[variable]);
  LOG('[environment] envCookie', envCookie);

  if (process.env[variable] === 'development') {
    return 'development';
  }

  if (envCookie === 'h') {
    return 'hlg';
  }

  return 'production';

  // if (isBrowser()) {
  //   return JSON.parse(decodeURI(window.__ISOMORPHIC_DATA__)).env[variable];
  // }

  // return process.env[variable];
}
